<template>
    <div class="job-detail" id="example-content" v-if="detail">
        <div class="job-detail-top">
          <div class="contentWidth flexBetween">
            <div class="shrink" style="width: 70%;">
              <div class="flex job-detail-top-name"> 
                <p class="">{{ detail.name }}<span>{{ detail.salaryRangeName }}</span></p>
                <!-- 猎头岗位标识 -->
                <span v-if="detail.headhunterPosition" class="headhunter-tag">猎头岗位</span>
              </div>
              <div class="flex job-detail-top-icon">
                <p v-show="detail.address"><i class="el-icon-location"></i>{{ detail.address }}</p>
                <p v-show="detail.qualificationsName"><i class="el-icon-s-management"></i>{{ detail.qualificationsName }}</p>
                <p v-show="detail.workExperienceName"><i class="el-icon-s-order"></i>{{ detail.workExperienceName }}</p>
                <p v-show="detail.numbers"><i class="el-icon-s-custom"></i>招聘{{ detail.numbers }}人</p>
                <p v-show="detail.positionTypeName"><i class="el-icon-menu"></i>{{ detail.positionTypeName }}</p>
              </div>
              <div class="flex job-detail-top-label" v-if="detail.welfareInfos && detail.welfareInfos.length>0">
                <Btns v-for="item in detail.welfareInfos" :key="item.id" :value="item.welfareName"></Btns>
              </div>
            </div>
            <div class="shrink job-detail-top-opeart flexColumn" >
              
              <div class="flex opeartBox">
                <div disabled class="opeartBtn isready" v-if="detail.delivery">已申请内推</div>
                <div class="opeartBtn" v-else @click="sendResume">申请内推</div>
                <p v-if="detail.favorite" class="shrink" @click="favoriteDelete()">
                  <span class="fonticon">&#xe623;</span>
                  <span>取消收藏</span>
                </p>
                <p v-else class="shrink" @click="favoriteAdd()">
                  <span class="fonticon">&#xe62f;</span>
                  <span>未收藏</span>
                </p>
            </div>
              
              <div v-if="shlefInfo">
                <div
                  class="chooseResume textOver"
                  @click="chooseResume(index)"
                  v-for="(item, index) in resumeList"
                  :key="index"

                >
                  <span class="fonticon" v-if="resumeIndex == index">&#xe637;</span>
                  <span class="fonticon" v-else>&#xe607;</span>

                  <span class="fonticon" v-if="index == 0">&#xe64a;</span>
                  <span class="fonticon" v-else>&#xe65d;</span>

                  <span class="resume-name">{{ item.fileName }}</span>
                </div>
              </div>

              <div class="flex"  v-else>
                <p class="flex itemsCenter" @click="goLogin"> 
                  <img src="../../assets/images/newicon/edit.png" alt=""> 填写在线简历</p>
                <p class="flex itemsCenter" @click="goLogin"> 
                  <img src="../../assets/images/newicon/batchfolding.png" alt="">上传附件简历</p>
              </div>
            </div>
          </div>
        </div>
        <div class="job-detail-main flexBetween contentWidth">
            <div class="job-detail-main-left">
              <div class="boxShadow">
                <div class="job-detail-main-left-title" >工作职责</div>
                <p class="job-detail-main-left-subtitle">岗位职责</p>
                <div class="text-content" v-html="detail.desc"></div>

                <div class="job-detail-main-left-title" style="padding-top: 20px;">工作要求</div>
                <p class="job-detail-main-left-subtitle">业务技能要求：</p>
                <div class="text-content" v-html="detail.requirements"></div>
                <p v-if="detail.hardCondition" class="job-detail-main-left-subtitle">硬性要求：</p>
                <div v-if="detail.hardCondition" class="text-content" v-html="detail.hardCondition"></div>
              </div>
              <div class="boxShadow  job-detail-main-address">
                <div class="job-detail-main-left-title" >工作地点</div>
                <p class="job-detail-main-left-subtitle">公司地址：{{ detail.address }}</p>
              </div>
            </div>
            <div class="job-detail-main-right job-detail-main-left">
              <!-- 公司信息 -->
              <div class="boxShadow">
                <div class="job-detail-main-left-title" >公司信息</div>
                <div class="flexBetween job-detail-main-right-title">
                  <div class="flex job-detail-main-right-company itemsCenter">
                    <img class="shrink" :src="detail.avatarUrl" alt="">
                    <p class="">{{ detail.companyName }}</p>
                  </div>
                  

                </div>
                <p class="job-detail-main-right-infos">企业行业：{{ detail.industryTypeName }}</p>
                <p class="job-detail-main-right-infos">融资阶段：{{detail.financeTypeName }}</p>
                <p class="job-detail-main-right-infos">公司规模：{{detail.scaleName }}</p>
                <div class="opear-btn" @click="checkAll(detail.companyId)">查看全部职位</div>
              </div>
              <!-- 相似职位推荐 -->
              <!-- <div class="boxShadow">
                <div class="job-detail-main-left-title" >相似职位推荐</div>
                <div>
                  <div class="flexBetween itemsCenter job-detail-main-right-subtitle">
                    <p>IE工程师</p>
                    <p>10-15K</p>
                  </div>
                  <div class="flexBetween job-detail-main-right-name">
                    <p class="flex itemsCenter ">
                      <img src="../../assets/images/newicon/icon.png" alt=""> 某知名科技公司的客服给的时刻打开肌肤健康的好好看好好
                    </p>
                    <p class="shrink">成都</p>
                  </div>
                  <div class="opear-btn opear-detail">查看详情</div>
                </div>
                <div class="opear-btn opear-more">查看更多职位</div>
              </div> -->
              <img src="../../assets/images/newicon/jobImg.png" alt="" class="job-detail-main-right-imgs"/>
            </div>
        </div>
    </div>
   
  </template>
  
  <script>
  import { mapActions, mapState,mapGetters } from "vuex";
  // import defaultAvatar from "../../assets/images/default-avatar.png";
  import indexDateli from "../../components/likeBrowsing/indexDateli.vue";
  import Btns from '../../components/Btn.vue'
  export default {
    components: {
      indexDateli,Btns
    },
    name: "session",
    data() {
      return {
        likeNum: "", //点赞数量
        browseNum: "", //浏览量
        isLike: "", // 是否点赞
  
        jobId: "", //职位ID
        detail: null, //详情数据
        affixStatus: false,
        offset: { top: 0, bottom: 0 },
        resumeList: [], //简历列表
        resumeIndex: 0, //选择的简历下标
        pushLoading: false,
        fullloading:null,
      };
    },
    computed: {
      ...mapState({
        shlefInfo: state => state.user.info //个人信息
      }),
      ...mapGetters(["isLogin"]),
    },
    async created() {
      this.jobId = this.$route.query.id;
      await this.getDetail();
      if(this.isLogin){
        await this.getAccessoryResume();
      }
    },
    methods: {
      
      ...mapActions([
        "getJobDetail",
        "addFavorite",
        "deleteFavorite",
        "accessoryResume",
        "sendOnlineResume",
        "sendAttachmentResume",
        "giveThumbsUp",
        "unGiveThumbsUp"
      ]),

      //填写在线简历
      goMyresume() {
        if (!this.isLogin) {
          this.$router.push("/login");
        } else {
          this.$router.push("/myresume");
        }
      },
      //查看全部职位
      checkAll(id){
        window.open(`/company/detail?id=${id}`);
      },

      affixChange() {
        //            this.affixStatus = e;
      },
      // 点赞
      async thumbsUpFn(id) {
        let params = { id: id };
        const data = await this.giveThumbsUp(params);
        if (data.code !== 200) {
          return this.$message.error(data.message);
        }
      },
      // 取消点赞
      async unThumbsUpFn(id) {
        let params = { id: id };
        const data = await this.unGiveThumbsUp(params);
        if (data.code !== 200) {
          return this.$message.error(data.message);
        }
      },
  
      // 获取附件简历
      async getAccessoryResume() {
        const res = await this.accessoryResume();
        res.data.unshift({
          id: "",
          fileName: "在线简历"
        });
        this.resumeList = res.data;
      },
      // 获得详情数据
      async getDetail() {
        const res = await this.getJobDetail(this.jobId);
        this.detail = res;
  
        this.likeNum = res.likeNum;
        this.browseNum = res.browseNum;
        this.isLike = res.isLike;
      },
      // 添加收藏职位
      async favoriteAdd() {
        if(!this.isLogin) return this.$message.warning("请先登陆！");
        const res = await this.addFavorite(this.detail.id);
          if (res) {
            this.detail.favorite = true;
            this.$message({
              message: "收藏成功",
              type: "success"
            });
          }
      },
      // 删除收藏职位
      async favoriteDelete() {
        if(!this.isLogin) return this.$message.warning("请先登陆！");
        const res = await this.deleteFavorite(this.detail.id);
        if (res) {
          this.detail.favorite = false;
          this.$message({
            message: "取消收藏成功",
            type: "success"
          });
        }
      },
      //未登录的情况下跳转到登录
      goLogin(){
        this.$router.push("/login");
      },

      // 选择简历
      async chooseResume(index) {
        this.resumeIndex = index;
      },
      // 投递简历
      async sendResume() {
        if(this.isLogin){
          // 投递在线简历
          this.pushLoading = true;
          // 打印的是当前已投递次数，下面两个TODO都是需要处理的
          // console.log(this.shlefInfo.positionStatistics.deliveredDay)
          if (this.resumeIndex == 0) {
            const confirmRes = await this.$confirm(
              `你当前投递的是在线简历，且今日已经申请内d推了(${this.shlefInfo.positionStatistics.deliveredDay})次,你确定申请内推吗？`,
              "提示",
              {
                cancelButtonText: "放弃内推",
                confirmButtonText: "申请内推",
                type: "warning"
              }
            );
            if (confirmRes !== "confirm") {
              return false;
            }
            this.fullloading = this.$loading({
              lock: true,
              text: "职位内推中...,请耐心等待",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            const res = await this.sendOnlineResume(this.detail.id);
            this.fullloading.close();
            if (res.code != 200) {
              let codes=[95070,95073,95076,95075,95077,95078]
              if (res.code == 98010) {
                this.$router.push("/login");
              }else if(codes.includes(res.code)){
                this.$confirm( `${res.message} `, '提示',{
                  confirmButtonText: '完善简历',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  this.$router.push("/myresume");
                }).catch(()=>{})
              }else{
                this.$message({
                  message: res.message,
                  type: "warning"
                });
              }
            } else {
              if (res.data && res.data.type) {
                this.editJump(res.data);
                return false;
              }
              await this.getDetail();
              this.$message({
                message: "申请成功",
                type: "success"
              });
            }
          } else {
            // 投递附件简历
            const fileName = this.resumeList[this.resumeIndex].fileName;
            const confirmRes = await this.$confirm(
              `你当前投递的是附件简历（${fileName}），且今日已经申请内推了${this.shlefInfo.positionStatistics.deliveredDay}次,你确定申请内推吗？`,
              "提示",
              {
                cancelButtonText: "放弃内推",
                confirmButtonText: "申请内推",
                type: "warning"
              }
            );
            if (confirmRes !== "confirm") {
              return false;
            }
            this.fullloading = this.$loading({
              lock: true,
              text: "职位内推中...,请耐心等待",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            const res = await this.sendAttachmentResume({
              positionId: this.detail.id,
              resumeId: this.resumeList[this.resumeIndex].id
            });
            this.fullloading.close();
            if (res.code != 200) {
              let codes=[95070,95073,95076,95075,95077,95078]
              if (res.code == 98010) {
                this.$router.push("/login");
              } else if(codes.includes(res.code)){
                this.$confirm(`${res.message} `, '提示',{
                  confirmButtonText: '完善简历',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  this.$router.push("/myresume");
                }).catch(()=>{})
              }
              else {
                this.$message({
                  message: res.message,
                  type: "warning"
                });
              }
            } else {
              if (res.data && res.data.type) {
                this.editJump(res.data);
                return false;
              }
              await this.getDetail();
              this.$message({
                message: "申请成功",
                type: "success"
              });
            }
          }
          this.pushLoading = false;
        }else{
          this.goLogin()
        }
      },
      async editJump(data) {
        await this.$confirm(data.typeDesc, "提示", {
          cancelButtonText: "放弃内推",
          confirmButtonText: "前往完善",
          type: "warning"
        });
        let isEdit = "1";
        let id = "";
        switch (data.type) {
          case 11:
            isEdit = "1";
            break;
          case 21:
            isEdit = "2";
            break;
          case 31:
            isEdit = "3";
            break;
          case 40:
            isEdit = "4";
            break;
          case 41:
            isEdit = "4";
            id = data.eduId;
            break;
          case 50:
            isEdit = "5";
            break;
          case 51:
            isEdit = "5";
            id = data.workId;
            break;
          case 60:
            isEdit = "6";
            break;
          case 61:
            isEdit = "6";
            id = data.projectId;
            break;
        }
        this.$router.push({
          path: "/myresume",
          query: {
            isEdit,
            id
          }
        });
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .linkTop {
    width: 100%;
    font-size: 14px;
  }
  .job-detail {
    background: #F9FBFF;
    
    &-top{
      height: 238px;
      background: url('../../assets/images/newicon/jobDetailTopBg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding-top: 56px;
      margin-bottom: 30px;
      .flexBetween{
        flex-wrap: nowrap;
        align-items: flex-start;
      }
      &-name{
        align-items: center;
        p{
          font-size: 28px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600 ;
          color: #333333;
          padding-right: 10px;
          span{
            color: #FF8A16;
            padding-left: 10px;
          }
        }
        .headhunter-tag{
          flex-shrink: 0;
          white-space: nowrap;
          height: 24px;
          line-height: 22px;
          padding: 0 8px;
          margin-left: 6px;
          border: 1px solid #287CF3;
          border-radius: 4px;
          background: rgba(40,124,243,0.1);
          color: #287CF3;
          font-size: 12px;
        }
      }
      &-icon{
        margin: 10px 0 16px;
        p{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          padding-right: 20px;
        }
      }
      &-label{
        flex-wrap: wrap;
        .btn{
          background: #fff;
        }
      }
      &-opeart{
        align-items: flex-start;
        .opeartBtn{
          cursor: pointer;
            width: 148px;
            height: 36px;
            line-height: 36px;
            background: #287CF3;
            box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
            border-radius: 6px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            margin-bottom: 16px;
            margin-right: 20px;
          
        }
        .isready{
          background-color: #c8c9cc;
        }
        .opeartBox{
          .shrink{
            height: 36px;
            line-height: 36px;
            text-align: center;
            border:  1px solid #287CF3;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #287CF3;
            border-radius: 6px;
            cursor: pointer;
            padding: 0 20px;
            .fonticon{
              padding-right: 4px;
            }
           
          }
        }
        

        p{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          padding-left: 20px;
          img{
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
        .chooseResume{
          width: 240px;
          padding-bottom: 6px;
          .fonticon{
            padding-left: 6px;
            cursor: pointer;
          }
          .resume-name{
            padding-left: 2px;
          }
        }
      }
    }
    &-main{
      align-items: flex-start;
       .boxShadow{
        padding: 24px;
        margin-bottom: 24px;
        background-color: #fff;
       }
       &-left{
        width: 954px;
        &-title{
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
          padding-bottom: 16px;
          margin-bottom: 16px;
          border-bottom: 1px solid  #EBEBEB;
        }
        &-subtitle{
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          padding-bottom: 10px;
        }
        .text-content{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          padding-bottom: 16px;
        }
       }
       &-right{
        width: 302px;
        .flexBetween{
          flex-wrap: nowrap;
          margin-bottom: 16px;
          
        }
        &-title{
          p{
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #287CF3;
          }
        }
        &-company{
          img{
            width: 48px;
            height: 48px;
            border-radius: 6px;
            margin-right: 4px;
          }
          p{
            color: #333333 !important;
          }
        }
        &-infos{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
        &-subtitle{
          p{
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            &:last-child{
              color: #FF8A16;
            }
          }
        }
        &-name{
          img{
            width: 24px;
            height: 24px;
            border-radius: 2px;
            margin-right: 6px;
          }
          p{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.55);
            line-height: 17px;
            &:last-child{
              padding-left: 10px;
            }
          }
        }
        &-imgs{
          width: 302px;
        }


       }
       .opear-btn{
          width: 254px;
          height: 36px;
          box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
          border-radius: 6px;
          border: 1px solid #287CF3;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #287CF3;
          line-height: 36px;
          text-align: center;
          margin-top: 24px;
          cursor: pointer;
          &:hover{
            background: rgba(40,124,243,0.2);;
          }
        }
        .opear-detail{
          margin: 16px 0 24px;
        }
        .opear-more{
          background: #287CF3;
          color: #fff;
          &:hover{
            background: #246FD9;
          }
        }
      
       
    }


    // margin-top: 56px;
    .vue-affix {
      width: 100%;
      z-index: 9;
    }
    &-header-affix {
      margin-top: 56px;
      padding-bottom: 45px !important;
      box-shadow: 0px 4px 10px 0px rgba(102, 102, 102, 0.36);
      .content {
        align-items: center;
        .job-label {
          margin-bottom: 0 !important;
        }
      }
    }
    &-header {
      // height: 235px;
      background: #049cfd;
      box-sizing: border-box;
      padding: 45px 0 20px;
      .content {
        width: 1200px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        &-left {
          font-size: 18px;
          color: #fff;
        }
        .job-money {
          display: block;
          // width: 86px;
          height: 30px;
          background: #ffffff;
          border-radius: 15px;
          color: #ff5555;
          // text-align: center;
          padding: 0 10px;
          line-height: 30px;
          margin-right: 18px;
        }
        .job-label {
          display: flex;
          align-items: center;
          margin: 16px 0;
          &-detail {
            font-size: 14px;
            color: #fff;
            display: flex;
            align-items: center;
            .separated {
              display: block;
              width: 1px;
              height: 8px;
              background: #ccc;
              margin: 0 10px;
            }
          }
        }
        .creat-time {
          font-size: 14px;
        }
        .company-name {
          margin-top: 35px;
          color: #fff;
          display: block;
        }
        &-right {
          width: 230px;
          &-operation {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .operation-apply {
            background: #fff;
            width: 150px;
            height: 40px;
            line-height: 40px;
            color: #049cfd;
            border-radius: 0;
            font-size: 18px;
            padding: 0;
            border: 0;
          }
          .operation-apply-done {
            width: 150px;
            background: #ccc;
            color: #fff;
          }
          .operation-collection {
            margin-left: 15px;
            width: 120px;
            // background: sienna;
            cursor: pointer;
            font-size: 14px;
            color: #fff;
            display: inline-block;
            .fonticon {
              font-size: 18px;
              margin-right: 8px;
            }
          }
        }
        .resume {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 14px;
          margin-top: 21px;
          cursor: pointer;
          .fonticon {
            font-size: 18px;
            &:nth-of-type(2) {
              margin: 0 4px 0 8px;
            }
          }
          &-name {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    // &-main {
    //   width: 1280px;
    //   margin: auto;
    //   box-sizing: border-box;
    //   padding-top: 42px;
    //   display: flex;
    //   justify-content: space-between;
    //   &-left {
    //     width: 943px;
    //   }
    //   &-right {
    //     width: 230px;
    //     .advertising {
    //       display: block;
    //       width: 100%;
    //       height: 206px;
    //       margin: 10px 0;
    //     }
    //   }
    // }
    .unify {
      .not-padding {
        padding-bottom: 0;
      }
      &-title {
        padding-bottom: 16px;
        border-bottom: 1px solid #e5e5e5;
        font-size: 16px;
        color: #333;
        position: relative;
        &.hard {
          color: #ff5555;
          .unify-title-decoration {
            background: #ff5555;
          }
        }
        &-decoration {
          width: 34px;
          height: 2px;
          background: #049cfd;
          position: absolute;
          left: 0;
          bottom: -1px;
        }
      }
      &-content {
        padding: 17px 0 40px;
        font-size: 14px;
        color: #666;
        line-height: 32px;
      }
      .map-address {
        line-height: 40px;
        height: 40px;
        background: #049cfd;
        font-size: 14px;
        color: #fff;
        box-sizing: border-box;
        padding-left: 20px;
        .fonticon {
          margin-right: 5px;
          font-size: 16px;
        }
      }
      
    }
  }
  .content-right-operation {
    width: 430px;
  }
  </style>
  